<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-18 18:17:56
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-11-11 14:09:02
 -->
<template>
  <div id="home-page">
    首页
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  components: {},
  data () {
    return {}
  },
  methods: {},
  created () {},
}
</script>

<style lang="less" scoped>
#home-page {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
</style>
